import { useCallback, useEffect, useState } from "react";

import { useSubscribe } from "data/messages/hooks";

export function useSubscribeToClientCardUpcomingReminders(onUpdate) {
  const [isRefetch, refetch] = useState(false);

  useEffect(() => {
    if (isRefetch) {
      onUpdate();
      refetch(false);
    }
  }, [isRefetch, onUpdate]);

  useSubscribe(
    "clientCardUpcomingReminders",
    useCallback((reloadSet) => {
      if (reloadSet && reloadSet.values().next().value) refetch(true);
    }, [])
  );
}

export default useSubscribeToClientCardUpcomingReminders;
